import "./App.css";
import { useState, useEffect } from "react";
import ProductList from "./components/ProductsList";
import Header from "./components/Header";
import Cart from "./components/Cart";

function App() {
  const [products, setProducts] = useState([]);
  const [currentSale, setCurrentSale] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);

  const handleClick = (productId) => {
    const cartProduct = products.find((product) => {
      return product.id === productId;
    });

    if (currentSale.includes(cartProduct)) {
      return currentSale;
    } else {
      return setCurrentSale([...currentSale, cartProduct]);
    }
  };

  const showProducts = () => {
    const searchInput = document.querySelector(".searchInput");
    const value = searchInput.value.toLowerCase();

    const filtered = products.filter((product) => {
      return product.name.toLowerCase().includes(value);
    });

    return filtered === []
      ? setFilteredProducts(products)
      : setFilteredProducts(filtered);
  };

  useEffect(() => {
    fetch("https://hamburgueria-kenzie-json-serve.herokuapp.com/products")
      .then((response) => response.json())
      .then((response) => {
        setProducts(response);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <main>
      <Header showProducts={showProducts} />
      <div className="container">
        {filteredProducts.length === 0 ? (
          <ProductList handleClick={handleClick} products={products} />
        ) : (
          <ProductList handleClick={handleClick} products={filteredProducts} />
        )}
        <Cart currentSale={currentSale} setCurrentSale={setCurrentSale} />
      </div>
    </main>
  );
}

export default App;
